var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "mb-2" },
        [_c("DrugSearchNew", { attrs: { onSelect: (d) => _vm.addDrug(d) } })],
        1
      ),
      _vm._v(" "),
      _vm.loadingList || _vm.drugsForSelect.length
        ? _c(
            "div",
            [
              _c("h5", [_vm._v("Рекоммендуемые препараты")]),
              _vm._v(" "),
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loadingList,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              _vm._l(_vm.drugsForSelect, function (d, i) {
                return _c(
                  "div",
                  {
                    staticClass:
                      "flex mt-1 border pl-2 align-items-center bg-gray",
                  },
                  [
                    _c("span", { staticClass: "flex-grow-1 mb-0 pr-1" }, [
                      _vm._v(_vm._s(d.title)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.addDrug(d)
                          },
                        },
                      },
                      [
                        _vm._v("привязать "),
                        _c("i", {
                          staticClass: "icon-fa icon-fa-arrow-circle-down",
                        }),
                      ]
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c("hr"),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h5", [_vm._v("Привязанные препараты")]),
      _vm._v(" "),
      _vm._l(_vm.drugs, function (d, i) {
        return !d.to_delete
          ? _c(
              "div",
              {
                staticClass: "flex mt-1 border pl-2 align-items-center bg-gray",
              },
              [
                _c("label", { staticClass: "flex-grow-1 mb-0 pr-1" }, [
                  _vm.drugs.length > 1
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mainDrug,
                            expression: "mainDrug",
                          },
                        ],
                        staticClass: "mr-2",
                        attrs: { type: "radio" },
                        domProps: {
                          value: d.drug.id,
                          checked: _vm._q(_vm.mainDrug, d.drug.id),
                        },
                        on: {
                          change: function ($event) {
                            _vm.mainDrug = d.drug.id
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {}, [_vm._v(_vm._s(d.drug.title))]),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.removeDrug(d.id)
                      },
                    },
                  },
                  [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
                ),
              ]
            )
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }